import React from 'react';

import LogoOntregel from '../Logos/LogoOntregel';

import './Header.css'

const Header = (props) => {

	return (
		<div className="Header">
			<div className="container">

				<LogoOntregel />

				<div className="InfoBox col-md-5 clearfix">
					<p>Het Roer Moet Om pakt in samenwerking met VvAA onzinnige regels in de zorg aan.</p>
					<a href="http://vvaa.nl/ontregeldezorg" target="_blank" rel="noopener noreferrer" className="btn btn-primary">Lees verder</a>
				</div>

			</div>
		</div>
		)

}

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header/Header.js